import FilesTemplate from './files.html';

export default angular
  .module('main.devices.edit.tabs.files', [])

  .directive('editDeviceFilesTab', () => {
    return {
      restrict: 'E',
      template: FilesTemplate,
      scope: {},
      controller: ($scope,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        angular.extend($scope, {});

        init();

        function init() {

        }
      }
    };
  })
  .name;
